import { Separator as e } from "../separator/index.js";
import { Link as t } from "../link/index.js";
import { getValidChildren as n } from "../../utils/index.js";
import { cloneElement as r, forwardRef as i } from "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
// src/design/breadcrumbs/@/components/item/index.tsx
var s = i(({ autoFocus: i, children: s, isLast: c, ...l }, u) => {
	let d = n(s).map((e) => e.type === t ? r(e, {
		autoFocus: i,
		isLast: c
	}) : e);
	return /* @__PURE__ */ o("li", {
		ref: u,
		...l,
		children: [d, !c && /* @__PURE__ */ a(e, {})]
	});
});
s.displayName = "Item";
export { s as Item };

//# sourceMappingURL=index.js.map